import { render, staticRenderFns } from "./CartTotalCard.vue?vue&type=template&id=397893b6&scoped=true&"
import script from "./CartTotalCard.vue?vue&type=script&lang=js&"
export * from "./CartTotalCard.vue?vue&type=script&lang=js&"
import style0 from "./CartTotalCard.vue?vue&type=style&index=0&id=397893b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397893b6",
  null
  
)

/* custom blocks */
import block0 from "./CartTotalCard.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "CartTotalCard.vue"
export default component.exports